// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createContainer,
	createActionsHook,
} from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import type { State, ContainerProps } from './types.tsx';

type Actions = typeof actions;
export const initialState: State = {
	deferredNavigationLink: '',
};

const store = createStore<State, Actions>({
	name: 'NavigationDiscardChanges',
	initialState,
	actions,
});

export const NavigationDiscardChangesContainer = createContainer<State, Actions, ContainerProps>(
	store,
);
export const useNavigationDiscardChanges = createHook(store);
export const useNavigationDiscardChangesActions = createActionsHook(store);
